import React, { useEffect, useRef, useState } from 'react';
import { ActualMatch } from '@/entities/forecast/ui/ActualMatch';
import { UpcomingMatch } from '@/entities/forecast/ui/UpcomingMatch';
import { MembersMatch } from '@/entities/forecast/ui/MembersMatch';
import { FonbetBanner } from '@/shared/ui/FonbetBanner';
import { useStore } from '@/app/providers/StoreProvider';
import { observer } from 'mobx-react-lite';
import { Loading } from '@/shared/ui/Loading';
import { IMatch } from '@/entities/forecast/types';
import { FinishMatch } from '@/entities/forecast/ui/FinishMatch';


export enum ForecastTabType {
  FORECAST = 'Прогнозы',
  MEMBERS = 'Участники',
}

export const ForecastPage = observer(() => {
  const { forecastStore, userStore } = useStore();
  const [tab, setTab] = useState<ForecastTabType>(ForecastTabType.FORECAST);
  const [match, setMatch] = useState<IMatch | null>(null);

  useEffect(()=>{
    const fetchData = async() =>{
       await forecastStore.getMatches();
       const actualMatch = forecastStore.getActualMatch();
       if(actualMatch){
          setMatch(actualMatch)
         await forecastStore.getBets(actualMatch.id);
       }
   }
   fetchData();
   },[])


  const isBet = forecastStore.isBet(userStore.user);

  if(forecastStore.loading) return <Loading/>
  return (

    <div className="forecast-page">

      <div className="container">

      <div className='tabs'>
        <div className={`tab ${tab === ForecastTabType.FORECAST?'active':''}`} onClick={()=>setTab(ForecastTabType.FORECAST)}>{ForecastTabType.FORECAST}</div>
        <div className={`tab ${tab === ForecastTabType.MEMBERS?'active':''}${forecastStore.bets.length == 0?'disabled':''}`} onClick={()=>forecastStore.bets.length != 0&&setTab(ForecastTabType.MEMBERS)}>{ForecastTabType.MEMBERS}</div>
      </div>

        {tab === ForecastTabType.FORECAST&&
        <>
          <ActualMatch match={match} isActual={false} isBet={isBet} showTitle={true}/>
          <UpcomingMatch />
          <FonbetBanner link='#'/>
        </>}
        {tab === ForecastTabType.MEMBERS&&<>
          <FinishMatch match={match}/>
          <ActualMatch match={match} isActual={false} isBet={isBet} showTitle={false}/>
          <MembersMatch />
        </>}
      </div>


    </div>
  );
});
